import { FC, FormEvent, useState } from 'react'
import { changePassword } from '../core/_requests'
import { accountErrorText, dataOf } from '../core/errors'
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '../core/_models'

const EMPTY = { current: '', next: '', repeat: '' }

export const PasswordCard: FC = () => {
  const [values, setValues] = useState(EMPTY)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)

  const set = (field: keyof typeof EMPTY) => (event: { target: { value: string } }) => {
    setValues((prev) => ({ ...prev, [field]: event.target.value }))
    setDone(false)
  }

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (loading) {
      return
    }

    setDone(false)
    if (values.next.length < PASSWORD_MIN_LENGTH || values.next.length > PASSWORD_MAX_LENGTH) {
      setError(`Новый пароль должен быть от ${PASSWORD_MIN_LENGTH} до ${PASSWORD_MAX_LENGTH} символов.`)
      return
    }
    if (values.next !== values.repeat) {
      setError('Пароли не совпадают.')
      return
    }

    setLoading(true)
    setError(null)
    try {
      dataOf(await changePassword(values.current, values.next))
      setValues(EMPTY)
      setDone(true)
    } catch (e) {
      setError(accountErrorText(e, 'Не удалось сменить пароль. Попробуйте ещё раз.'))
    } finally {
      setLoading(false)
    }
  }

  const field = (id: string, label: string, key: keyof typeof EMPTY, autoComplete: string) => (
    <div className='mb-5'>
      <label className='form-label fw-bold' htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        type='password'
        autoComplete={autoComplete}
        className='form-control'
        style={{ maxWidth: 360 }}
        value={values[key]}
        disabled={loading}
        onChange={set(key)}
      />
    </div>
  )

  return (
    <div className='card mb-7'>
      <div className='card-header'>
        <h3 className='card-title fw-bold'>Смена пароля</h3>
      </div>
      <form className='card-body' onSubmit={submit} noValidate>
        {field('account_password_current', 'Текущий пароль', 'current', 'current-password')}
        {field('account_password_new', 'Новый пароль', 'next', 'new-password')}
        {field('account_password_repeat', 'Повторите новый пароль', 'repeat', 'new-password')}

        {error && <div className='text-danger mb-4'>{error}</div>}
        {done && <div className='text-success mb-4'>Пароль изменён.</div>}

        <button
          type='submit'
          className='btn btn-primary'
          disabled={loading || values.current === '' || values.next === '' || values.repeat === ''}
        >
          {loading ? (
            <>
              Сохраняем... <span className='spinner-border spinner-border-sm align-middle ms-2' />
            </>
          ) : (
            'Сменить пароль'
          )}
        </button>
      </form>
    </div>
  )
}
